import { render, staticRenderFns } from "./RuleCustomList.vue?vue&type=template&id=ff2be862&scoped=true&"
import script from "./RuleCustomList.vue?vue&type=script&lang=js&"
export * from "./RuleCustomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2be862",
  null
  
)

export default component.exports